var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("推荐位管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("推荐位列表"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "标题" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入标题",
                                  },
                                  model: {
                                    value: _vm.ruleForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "name", $$v)
                                    },
                                    expression: "ruleForm.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择状态" },
                                    model: {
                                      value: _vm.ruleForm.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "status", $$v)
                                      },
                                      expression: "ruleForm.status",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "上架", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "下架", value: "1" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                staticStyle: { "margin-bottom": "16px" },
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.add()
                  },
                },
              },
              [_vm._v("添加")]
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "title", label: "标题", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "强制观看", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.isForceView == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("是"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.isForceView == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("否"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "关闭类型", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.closeType == 0
                            ? _c("span", [_vm._v("不关闭")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.closeType == 1
                            ? _c("span", [_vm._v("查看后关闭")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.closeType == 2
                            ? _c("span", [_vm._v("手动关闭")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "closeTime",
                    label: "倒计时(秒)",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "适配端", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm._l(_vm.config, function (item, index) {
                          return item.key == scope.row.useType
                            ? _c("span", { key: index }, [
                                _vm._v(_vm._s(item.val)),
                              ])
                            : _vm._e()
                        })
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "类型", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm._l(_vm.cageryList, function (item, index) {
                          return item.id == scope.row.categoryId
                            ? _c("span", { key: index }, [
                                _vm._v(_vm._s(item.name)),
                              ])
                            : _vm._e()
                        })
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.saleStatus == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("下架"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.saleStatus == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("上架"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "gmtCreate",
                    label: "创建时间",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            scope.row.saleStatus == 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn greenColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                启用\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.saleStatus == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn redColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                禁用\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                编辑\n              ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn redColor1",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                删除\n              ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }